import { AppService } from "../../app.service";
var SideBarComponent = (function () {
    function SideBarComponent(appService) {
        this.appService = appService;
    }
    SideBarComponent.prototype.ngOnInit = function () {
        this.isAdmin = this.appService.getCurrentUser().role == 'ADMIN';
    };
    return SideBarComponent;
}());
export { SideBarComponent };



// WEBPACK FOOTER //
// /build/client-cms/src/app/layout/side-bar/side-bar.component.ts.pre-build-optimizer.js